// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import './../../scss/slider/slider.scss';

export class SlideTeasers {
    constructor(element, slides = 1) {
        this.slider = false;
        this.holder = document.querySelector(element);
        this.slides = slides;
        this.space = 22;
        this.offset = 0;
        this.center = true;
        this.centeredSlidesBounds = true;
        this.loop = false;
        this.navigation = {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        };
        this.pagination = {
            el: '.swiper-pagination',
        };
        this.init();
    };

    init() {
        if (this.holder) {
            //let slides = this.holder.querySelectorAll('.swiper-slide');
            /*
            if (slides.length <= this.slides) {
                this.loop = false;
                this.center = true;
                this.centeredSlidesBounds = true;
                this.pagination = false;
            }
            */

            this.slider = new Swiper(this.holder, {
                loop: this.loop,
                slidesPerView: this.slides,
                spaceBetween: this.space,
                centeredSlides: this.center,
                centeredSlidesBounds: this.centeredSlidesBounds,
                centerInsufficientSlides: true,
                preventClicks: false,
                loopAddBlankSlides: false,
                
                autoplay: {
                    delay: 5000,
                },
                
                pagination: this.pagination,
                navigation: this.navigation,
                
                breakpoints: {
                    1: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        centeredSlides: false,
                        centeredSlidesBounds: false,
                        loop: false,
                    },
                    1024: {
                        slidesPerView: this.slides,
                        spaceBetween: this.space,
                        centeredSlides: this.center,
                        centeredSlidesBounds: this.centeredSlidesBounds,
                    },
                },
                
                on: {
                    click() {
                        let ele = this.slides[this.clickedIndex];
                        if (ele.dataset.link != 'undefined' && ele.dataset.link !== null) {
                            window.location.href = ele.dataset.link;
                        }
                    },
                }
            });
        }
    };
};
